import Layout from "@/components/Layout";
import { UsuariosContent } from "@/components/configuracion/UsuariosContent";

export default function Usuarios() {
  return (
    <Layout>
      <UsuariosContent />
    </Layout>
  );
}
